import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mentions',
  templateUrl: './mentions.component.html',
  styleUrls: ['./mentions.component.css', '../../edito/edito.css']
})
export class MentionsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
